import { render } from "./RecordAudio.vue?vue&type=template&id=b8784608&scoped=true"
import script from "./RecordAudio.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordAudio.vue?vue&type=script&setup=true&lang=js"

import "./RecordAudio.vue?vue&type=style&index=0&id=b8784608&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8784608"],['__file',"resources/js/components/whatsapp-managment/includes/types/RecordAudio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8784608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8784608', __exports__)) {
    console.log('reload')
    api.reload('b8784608', __exports__)
  }
  
  module.hot.accept("./RecordAudio.vue?vue&type=template&id=b8784608&scoped=true", () => {
    console.log('re-render')
    api.rerender('b8784608', render)
  })

}


export default __exports__